import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import MaintenancePage from './MaintenancePage';
import useBackendHealth from './useBackendHealth';
import { useMaintenance } from './MaintenanceContext';
const MaintenanceGate = ({ children }) => {
    const { maintenance } = useMaintenance();
    const { retry } = useBackendHealth();
    if (maintenance) {
        return _jsx(MaintenancePage, { onRetry: retry });
    }
    return _jsx(_Fragment, { children: children });
};
export default MaintenanceGate;
